import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';

import TextCell from 'app/components/data-table/TextCell';

export default function PipelinesCell({ row }) {
  return <TextCell text={buildPipelineNames(row.pipelineTags)} noWrap />;
}

function buildPipelineNames(pipelineTags) {
  return map(pipelineTags, 'pipeline.name').join(', ');
}

PipelinesCell.propTypes = {
  row: PropTypes.shape({
    pipelineTags: PropTypes.arrayOf(
      PropTypes.shape({
        pipeline: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }).isRequired,
      })
    ).isRequired,
  }).isRequired,
};
